import { i18nMark } from 'lingui-react';

const messages = {
  collapse: i18nMark('Collapse Note'),
  expand: i18nMark('Expand Note'),
  markAsRead: i18nMark('Mark as Read'),
  markAsUnread: i18nMark('Mark as Unread'),
  readAt: i18nMark('{date}'),
  reply: i18nMark('Reply'),
  more: i18nMark('... {count} more'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/Note/messages.js